module.exports = __webpack_public_path__ + "img/mukul-verma.9ffbed72.jpg";